module.exports = __webpack_public_path__ + "media/images/illustrations/lock-03e29361aaf796eb93d840cc587889e2.svg";